/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_DetailsInputs */

const en_us2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise details`)
};

const pt_br2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do exercício`)
};

const es_419_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del ejercicio`)
};

const pt_pt2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do exercício`)
};

const fr_fr2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l'exercice`)
};

const de_de2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungsdetails`)
};

const it_it2_workout_details = /** @type {(inputs: Workout_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli dell'esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise details" |
*
* @param {Workout_DetailsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_details = /** @type {((inputs?: Workout_DetailsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_DetailsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_details(inputs)
	if (locale === "es-419") return es_419_workout_details(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_details(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_details(inputs)
	if (locale === "de-DE") return de_de2_workout_details(inputs)
	if (locale === "it-IT") return it_it2_workout_details(inputs)
	return en_us2_workout_details(inputs)
});
export { workout_details as "workout.details" }